import { createFormContext, isNotEmpty } from '@mantine/form';
import { featureCollection, multiPolygon } from '@turf/turf';
import { Feature, Polygon } from 'geojson';
import { useTranslation } from 'react-i18next';

import { CreateFieldDto } from '@fields/data-access';

interface FieldFormValues {
  name: string;
  farm: string;
  species?: string;
  variety?: string;
  boundaries?: Feature<Polygon>[];
}

export type TransformValues = (values: FieldFormValues) => CreateFieldDto;

const [FieldFormProvider, useFieldFormContext, useForm] = createFormContext<
  FieldFormValues,
  TransformValues
>();

export function useFieldForm() {
  const { t } = useTranslation();
  const form = useForm({
    initialValues: {
      name: '',
      farm: '',

      boundaries: [],
    },
    validate: {
      farm: isNotEmpty(t('forms.required')),

      boundaries: (value) => {
        if (value?.length === 0) {
          return t('forms.required');
        }

        return undefined;
      },
    },
    transformValues(values) {
      const { name, farm, species, boundaries, variety } = values;

      const transformedValues: CreateFieldDto = {
        name,
        farm: Number(farm),

        boundaries: featureCollection([]),
      };

      if (species) {
        transformedValues.species = Number(species);
      } else {
        transformedValues.species = undefined;
      }

      if (variety) {
        transformedValues.variety = Number(variety);
      } else {
        transformedValues.variety = undefined;
      }

      if (boundaries) {
        const mP = multiPolygon(
          boundaries.map((f) => f.geometry.coordinates),
          {},
        );

        transformedValues.boundaries = featureCollection([mP]);
      }

      return transformedValues;
    },
  });

  return form;
}

export { FieldFormProvider, useFieldFormContext };
